import {
    Box,
    FormControl,
    Icon,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Stack,
    Tab,
    Tabs,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AdDetailDto, AdService } from "../../../api/psc";
import { Spinner } from "../../../components/exports";
import AdDetailList from "../components/AdDetailList";
import AdDetailMap from "../components/AdDetailMap";

enum ViewType {
    Map = 1,
    List = 2,
}

export default function AdDetailPage() {
    let { id } = useParams();

    const [ad, setAd] = useState<AdDetailDto | null>(null);
    const [viewType, setViewType] = useState<ViewType>(ViewType.Map);
    const [selectedRegion, setSelectedRegion] = useState<number>(0);

    const theme = useTheme();
    const isMediumOrUp = useMediaQuery(theme.breakpoints.up("sm"));

    useEffect(() => {
        AdService.getAdDetail(parseInt(id), "1").then((r) => {
            setAd(r);
        });
    }, []);

    const handleViewTypeChange = (
        event: React.MouseEvent<HTMLElement>,
        value: ViewType
    ) => {
        if (!value) {
            return;
        }
        setViewType(value);
    };

    const handleRegionChangeTabs = (
        event: React.SyntheticEvent,
        region: number
    ) => {
        setSelectedRegion(region);
    };

    const handleRegionChangeSelect = (event: SelectChangeEvent<number>) => {
        setSelectedRegion(event.target.value as number);
    };

    if (!ad) {
        return <Spinner />;
    }

    return (
        <Box>
            <Stack
                direction="row"
                alignItems="center"
                sx={{
                    px: { xl: 3, lg: 3, md: 3, sm: 3, xs: 2 },
                    bgcolor: "background.paper",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 60,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                }}
            >
                {isMediumOrUp && (
                    <Tabs
                        sx={{ height: "100%", alignItems: "end" }}
                        value={selectedRegion}
                        onChange={handleRegionChangeTabs}
                    >
                        <Tab value={0} label="همه مناطق" />
                        {ad.regions.map((r) => {
                            return (
                                <Tab
                                    key={r.region.id}
                                    value={r.region.id}
                                    label={r.region.title}
                                />
                            );
                        })}
                    </Tabs>
                )}

                {!isMediumOrUp && (
                    <FormControl>
                        <InputLabel>نوع نمایش</InputLabel>
                        <Select
                            size="small"
                            value={selectedRegion}
                            label="نوع نمایش"
                            onChange={handleRegionChangeSelect}
                        >
                            <MenuItem value={0}>همه مناطق</MenuItem>
                            {ad.regions.map((r) => {
                                return (
                                    <MenuItem
                                        key={r.region.id}
                                        value={r.region.id}
                                    >
                                        {r.region.title}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                )}

                <Box flexGrow={1} />

                <Stack justifyContent="center" sx={{ height: "100%" }}>
                    <ToggleButtonGroup
                        value={viewType}
                        size="small"
                        exclusive
                        onChange={handleViewTypeChange}
                    >
                        <ToggleButton color="primary" value={ViewType.Map}>
                            <Tooltip title="نمایش روی نقشه">
                                <Icon>map</Icon>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton color="secondary" value={ViewType.List}>
                            <Tooltip title="نمایش به صورت لیست">
                                <Icon>menu</Icon>
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Stack>

            {viewType === ViewType.Map && (
                <AdDetailMap ad={ad} region={selectedRegion} />
            )}

            {viewType === ViewType.List && (
                <AdDetailList ad={ad} region={selectedRegion} />
            )}
        </Box>
    );
}
